var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "yxtbiz-circle-audit" }, [
    _c(
      "div",
      { staticClass: "standard-size-16 color-gray-10" },
      [
        _c("div", { staticClass: "font-bolder" }, [
          _vm._v(_vm._s(_vm.$t("pc_biz_bbs_lbl_joinerInfo" /**加入人信息 */))),
        ]),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_name" /** 姓名 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  { attrs: { "open-filter": true, placement: "top" } },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "content" }, slot: "content" },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.detail.fullName },
                        }),
                        _c("span", [
                          _vm._v(_vm._s("（" + _vm.detail.username + "）")),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "yxtbiz-circle-audit_ellipsis" },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.detail.fullName || "" },
                        }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.detail.username,
                                expression: "detail.username",
                              },
                            ],
                          },
                          [_vm._v(_vm._s("（" + _vm.detail.username + "）"))]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_dept" /**  部门 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  { attrs: { placement: "top", "open-filter": true } },
                  [
                    _c("yxtbiz-dept-name", {
                      attrs: { slot: "content", name: _vm.detail.deptName },
                      slot: "content",
                    }),
                    _c("yxtbiz-dept-name", {
                      staticClass: "yxtbiz-circle-audit_ellipsis",
                      attrs: { name: _vm.detail.deptName || "--" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "yxtf-row",
          {
            staticClass: "mv24 font-normal font-size-14",
            attrs: { type: "flex" },
          },
          [
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_possion" /**岗位 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  { attrs: { "open-filter": true, placement: "top" } },
                  [
                    _c("yxtbiz-position-name", {
                      attrs: { slot: "content", name: _vm.detail.positionName },
                      slot: "content",
                    }),
                    _c("yxtbiz-position-name", {
                      staticClass: "yxtbiz-circle-audit_ellipsis",
                      attrs: { name: _vm.detail.positionName || "--" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "yxtf-col",
              { staticClass: "mh2 flex", attrs: { span: 12 } },
              [
                _c("span", { staticClass: "color-gray-7 nowrap" }, [
                  _vm._v(
                    _vm._s(_vm.$t("pc_biz_bbs_lbl_circle" /**圈子 */)) + "："
                  ),
                ]),
                _c(
                  "yxtf-tooltip",
                  {
                    attrs: {
                      "open-filter": true,
                      content: _vm.detail.scName,
                      placement: "top",
                    },
                  },
                  [
                    _c("div", { staticClass: "yxtbiz-circle-audit_ellipsis" }, [
                      _vm._v(_vm._s(_vm.detail.scName || "--")),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }